var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66711 10.5C5.90961 10.5 2.84961 13.02 2.84961 16.125C2.84961 16.335 3.01461 16.5 3.22461 16.5H16.1096C16.3196 16.5 16.4846 16.335 16.4846 16.125C16.4846 13.02 13.4246 10.5 9.66711 10.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4495 2.745C11.7745 1.98 10.7695 1.5 9.66699 1.5C8.61699 1.5 7.65699 1.9275 6.97449 2.6325C6.32199 3.3075 5.91699 4.2375 5.91699 5.25C5.91699 5.955 6.11199 6.615 6.46449 7.1775C6.65199 7.5 6.89199 7.7925 7.17699 8.0325C7.82949 8.6325 8.69949 9 9.66699 9C11.0395 9 12.2245 8.265 12.877 7.1775C13.072 6.855 13.222 6.495 13.3045 6.12C13.3795 5.8425 13.417 5.55 13.417 5.25C13.417 4.29 13.0495 3.4125 12.4495 2.745ZM11.0695 5.94H8.26449C7.87449 5.94 7.55949 5.625 7.55949 5.235C7.55949 4.845 7.87449 4.53 8.26449 4.53H11.0695C11.4595 4.53 11.7745 4.845 11.7745 5.235C11.7745 5.625 11.4595 5.94 11.0695 5.94Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMinus);
export default __webpack_public_path__ + "static/media/user-minus.f5c175943b707767d93fbeb3d1408138.svg";
export { ForwardRef as ReactComponent };